$(document).ready(function() {
	$('.js-scroll-down').click(function() {
        $('html, body').animate({
            scrollTop: $(".site-main").offset().top
         }, 500);
	});
});